import { trackUserClick } from '@hc-frontend/third-party-snowplow'
import {
  buildSpValueToString,
  parseObjToStringWithComma
} from 'utils/snowplow/utils/buildSpValueToString'
import { getSPCategory } from 'utils/snowplow/utils/getSPCategory'

const mapCensusFun = item => {
  return {
    zip_code: item.location.zip_code,
    coverageType: item.coverageTypeSelection,
    dob: item.members[0].stringDOB,
    gender: item.members[0].gender,
    first_name: item.contact.first_name,
    email_address: item.contact.email_address,
    period: item.period,
    childOnly: item.childOnlySMT
  }
}

const mapMemberFun = item => {
  return {
    id: item.id,
    gender: item.gender,
    dob: item.stringDOB
  }
}

function sendSnowplowClickTrackEvent(hcStorage) {
  const trackingData = {
    category: getSPCategory(),
    placement: 'census-form',
    action: 'submit',
    label: 'Find Plans',
    value: getCensusFromStorage(hcStorage),
    elementId: 'submit-form',
    description: 'Census - submit'
  }

  return trackUserClick(trackingData)
}

function getCensusFromStorage(hcStorage): string {
  const censusData = buildSpValueToString(
    hcStorage,
    mapCensusFun,
    parseObjToStringWithComma
  )
  let familyInformation = ''
  if (hcStorage.members.length > 1) {
    familyInformation =
      ',' +
      buildSpValueToString(
        hcStorage.members.slice(1),
        mapMemberFun,
        parseObjToStringWithComma
      )
  }

  return censusData + familyInformation
}

export default sendSnowplowClickTrackEvent
